// extracted by mini-css-extract-plugin
module.exports = {"grid":"gallery-module--grid--3WMST","item":"gallery-module--item--2TrxR"};